import React from 'react';
import { CnLayoutPage as UICnLayoutPage } from '@cainiaofe/cn-ui';
const CnLayoutPage = (props) => {
    const { children } = props || {};
    return <UICnLayoutPage>{children}</UICnLayoutPage>;
};
CnLayoutPage.displayName = 'CnLayoutPage';
export default CnLayoutPage;
export { CnLayoutPage };
